import React from 'react';
import { Dialog } from '@alifd/next';
// import { Form } from 'antd';
import Button from '@/components/Button';
import { Input, Radio } from '@b-design/fusion';
import { Form, FormInstance } from 'antd';
import $i18n from '@/i18n';
// import Requests from '@/services/request';

// const { Option } = Select;
// const FormItem = Form.Item;
// const RadioGroup = Radio.Group;

interface InviteModal {
  inviteVisible: boolean;
  onInviteClose: () => void;
  onFinish: (values: any) => void;
  form: FormInstance;
  // spaceId: string | (string | null)[] | null
}

const Invite: React.FC<InviteModal> = ({
  inviteVisible,
  onInviteClose,
  onFinish,
  form,
  // spaceId
}) => {
  return (
    <div>
      <Dialog
        v2
        title={$i18n.get({ id: 'aopf.pages.invitation.invite', dm: '邀请' })}
        visible={inviteVisible}
        // TODO
        onOk={() => {
          form?.submit();
        }}
        onClose={onInviteClose}
        footerActions={['cancel', 'ok']}
        width={800}
        className="modal-addMember"
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={onInviteClose}>
              {$i18n.get({ id: 'aopf.component.invite.Cancel', dm: '取消' })}
            </Button>
            <Button type="primary" onClick={() => { form?.submit() }}>
              {$i18n.get({ id: 'aopf.component.invite.Ok', dm: '确定' })}
            </Button>
          </div>,
        ]}
      >
        <Form
          form={form}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          initialValues={{
            remember: true,
          }}
          labelAlign="left"
          onFinish={onFinish}
          autoComplete="off"
          colon={false}
        >
          <Form.Item
            label={$i18n.get({ id: 'aopf.pages.member.addMemberName', dm: '名称' })}
            name="invitee"
            rules={[
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.pages.member.addMemberNameErrorTips',
                  dm: '请输入名称',
                }),
              },
            ]}
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.member.addMemberNamePlacehold',
                dm: '输入具有2-36个字符的唯一名称。',
              })}
              style={{ width: '470px' }}
            />
          </Form.Item>

          <Form.Item
            label={$i18n.get({ id: 'aopf.pages.member.addMemberEmail', dm: '邮箱' })}
            name="inviteEmail"
            rules={[
              {
                type: 'email',
                message: $i18n.get({
                  id: 'aopf.pages.member.addMemberEmailErrorTips',
                  dm: '输入的电子邮件无效',
                }),
              },
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.pages.member.addMemberEmailErrorTip',
                  dm: '请输入邮箱',
                }),
              },
            ]}
          >
            <Input placeholder="example@email.com" style={{ width: '470px' }} />
          </Form.Item>

          <Form.Item
            label={$i18n.get({
              id: 'aopf.pages.space.InvitationValidity',
              dm: '邀请有效期',
            })}
            name="validDate"
            rules={[
              {
                required: true,
                message: $i18n.get({
                  id: 'aopf.pages.member.addMemberInvitationValidityErrorTip',
                  dm: '请选择邀请有效期',
                }),
              },
            ]}
            required
            initialValue={1}
          >
            <Radio.Group>
              <Radio value={1}>
                <span className="roleTitle">
                  {$i18n.get({
                    id: 'aopf.pages.member.addMemberInvitationValidityItem',
                    dm: '24小时',
                  })}
                </span>
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Dialog>
    </div>
  );
};
export default Invite;
